import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Button from 'components/UI/Button'
import AppContext from 'components/AppContext'

const UserEditAdPostDataLostWarning = ({ onClose }) => {
    const { t } = useTranslation('editProfile')

    return (
        <AppContext.div context="userEditAdPostDataLostWarning">
            <p>{t('editProfile:userEditAdPostDataLostWarning.description')}</p>
            <div className="action-wrapper">
                <Button
                    className="button"
                    onClick={() => onClose()}
                    trackName="stay"
                >
                    {t('editProfile:userEditAdPostDataLostWarning.stay')}
                </Button>
                <Button
                    className="button button--secondary"
                    onClick={() => window.history.back()}
                    trackName="leave"
                >
                    {t('editProfile:userEditAdPostDataLostWarning.leave')}
                </Button>
            </div>
        </AppContext.div>
    )
}

UserEditAdPostDataLostWarning.propTypes = {
    onClose: PropTypes.func.isRequired,
}

export default UserEditAdPostDataLostWarning
